module.exports = __webpack_public_path__ + "components/flag/static/square/it-193ff963f24bfb7174f37db51076c2b5.svg";